import { render, staticRenderFns } from "./VDataTableQuotesGrouped.vue?vue&type=template&id=308acd48&scoped=true"
import script from "./VDataTableQuotesGrouped.vue?vue&type=script&lang=js"
export * from "./VDataTableQuotesGrouped.vue?vue&type=script&lang=js"
import style0 from "./VDataTableQuotesGrouped.vue?vue&type=style&index=0&id=308acd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308acd48",
  null
  
)

export default component.exports